// signup_data_voucher.js
import { ref, computed } from 'vue'

// by convention, composable function names start with "use"
export function useSignupDataVoucher() {
	// state encapsulated and managed by the composable
	const signup_data_voucher = ref({
		// Prices
		total: 0,
		subtotal: 0,
		discount: 0,
		// Voucher
		voucher_code: '',
		balance_discount: 0,
		voucher: {
			voucher: undefined,
			referrer: '',
			hasAddons: false,
			addons: [],
			offer_title: '',
			offer_description: '',
			brew_method: '',
		},
	})

	const offer = computed(() => {
		return signup_data_voucher.value.voucher_code !== '' ? signup_data_voucher.value.voucher : undefined
	})

	const voucher_items = computed(() => {
		return offer.value?.voucher_items || []
	})

	const delivery_type = computed(() => {
		if (offer.value !== undefined) {
			if (voucher_items.value && voucher_items.value.length > 0) return false
		}
		return true
	})

	const ignore_card = computed(() => {
		return offer.value === undefined || (Object.keys(offer.value).length === 0 && offer.value.constructor === Object)
			? false
			: !offer.value.requires_payment_method
	})

	function handleVoucherInfo(result) {
		if (result.status === 'ok')
			signup_data_voucher.value.voucher = result.data
	}
	function clearVoucher(new_price) {
		signup_data_voucher.value.voucher = {}
		signup_data_voucher.value.voucher_code = ''
		signup_data_voucher.value.total = new_price
		signup_data_voucher.value.subtotal = new_price
		signup_data_voucher.value.discount = 0
		signup_data_voucher.value.voucher_discount = 0
		signup_data_voucher.value.balance_discount = 0
		// should we also clear cookie?
	}

	function updateVoucherData(new_data) {
		signup_data_voucher.value = { ...signup_data_voucher.value, ...new_data }
		//console.log('voucher', signup_data_voucher.value)
	}
	// expose managed state as return value
	return { signup_data_voucher, handleVoucherInfo, clearVoucher, updateVoucherData, voucher_items, delivery_type, ignore_card }
}
/*

*/
